import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Select, message,Tabs } from 'antd';
import { loginRequest } from '../../authConfig';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';
import MassUploadUserRole from './MassUploadUserRole';

const { TabPane } = Tabs;

const { Option } = Select;

const API_URL = process.env.REACT_APP_API_URL;




interface UserRole {
  userId: string;
  customRoleId: string[];
  departmentId?: string;
  departmentName?: string;
  businessUnitName?: string;
  isActive?: boolean;
}

interface RoleData {
  userId: string;
  customRoleId: string;
  departmentId?: string;
  departmentName?: string;
  businessUnitName?: string;
  isActive?: boolean;
}



// const assignUserRole = async (userRoles: { userId: string; customRoleId: string[]; departmentId?: string; departmentName?: string; businessUnitName?: string; isActive?: boolean }) => {
//   for (let i = 0; i < userRoles.customRoleId.length; i++) {
//     console.log("Sending role data:", userRoles.customRoleId[i]);
//     const roleData = {
//       userId: userRoles.userId,
//       customRoleId: userRoles.customRoleId[i],
//       departmentId: userRoles.departmentId,
//       departmentName: userRoles.departmentName,
//       businessUnitName: userRoles.businessUnitName,
//       isActive: userRoles.isActive,
//     };
//     console.log("Sending role data:", roleData);
//     await axios.post(`${API_URL}/api/Roles/CustomUserRole`, roleData);
//   }
// };
// const assignUserRole = async (userRole: { userId: string; customRoleId: string; departmentId?: string; departmentName?: string; businessUnitName?: string; isActive?: boolean }) => {
//   const response = await axios.post(`${API_URL}/api/Roles/CustomUserRole`, userRole);
//   return response.data;
// };

const UserRoleInput: React.FC = () => {
  const [roles, setRoles] = useState<{ customRoleId: string; customRoleName: string }[]>([]);
  const [userId, setUserId] = useState('');
  const [userName, setUserName] = useState('');
  const [department, setDepartment] = useState('');
  const [departmentName, setDepartmentName] = useState('');
  const [businessUnitName, setBusinessUnitName] = useState('');
  const [isActive, setIsActive] = useState(true);
  const [selectedRoles, setSelectedRoles] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [recipientSearchResults, setRecipientSearchResults] = useState<{ id: string; displayName: string }[]>([]);
  const { instance, accounts } = useMsal();

  const fetchToken = async () => {
    const res = await instance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0]
    });
    return res.idToken;
  };

  useEffect(() => {
    fetchToken();
  }, []);

const fetchRoles = async () => {
const token = await fetchToken(); 
const response = await axios.get(`${API_URL}/api/Roles`,{
  headers: {Authorization: `Bearer ${ token}`}});
return response.data;
};

const fetchUsers = async (searchTerm: string) => {
  const token = await fetchToken(); 
const response = await axios.get(`${API_URL}/api/Users/search?search=${encodeURIComponent(searchTerm)}`,{headers: {Authorization: `Bearer ${token}`}});
return response.data;
};

const fetchUserDetails = async (userId: string) => {
  const token = await fetchToken();
const response = await axios.get(`${API_URL}/api/Roles/CustomUserRoles/${userId}`,{
  headers: {Authorization: `Bearer ${token}`}});
return response.data;
};

const assignUserRole = async (userRoles: UserRole): Promise<void> => {
  const token = await fetchToken(); 
  const roleDataList: RoleData[] = userRoles.customRoleId.map(customRoleId => ({
    userId: userRoles.userId,
    customRoleId: customRoleId,
    departmentId: userRoles.departmentId,
    departmentName: userRoles.departmentName,
    businessUnitName: userRoles.businessUnitName,
    isActive: userRoles.isActive,
  }));
  await axios.post(`${API_URL}/api/Roles/CustomUserRole`, roleDataList, {headers: {Authorization: `Bearer ${token}`}});
};

  useEffect(() => {
    const loadRoles = async () => {
      try {
        const rolesData = await fetchRoles();
        setRoles(rolesData);
      } catch (error) {
        message.error('Failed to load roles');
      }
    };
    loadRoles();
  }, []);

  useEffect(() => {
    const fetchNomineeData = async () => {
      if (searchTerm.length < 3) {
        setRecipientSearchResults([]);
        return;
      }
      try {
        const data = await fetchUsers(searchTerm);
        setRecipientSearchResults(data);
      } catch (error) {
        console.error('Error fetching recipients:', error);
      }
    };
    fetchNomineeData();
  }, [searchTerm]);

  const handleRecipientClick = async (value: string) => {
    try {
      const userDetails = await fetchUserDetails(value);
      if (userDetails && userDetails.length > 0) {
        const firstUserDetail = userDetails[0];
        setUserId(firstUserDetail.userId);
        setUserName(firstUserDetail.displayName);
        setDepartment(firstUserDetail.departmentId);
        setDepartmentName(firstUserDetail.departmentName);
        setBusinessUnitName(firstUserDetail.businessUnitName);
        setIsActive(firstUserDetail.isActive);
        setSelectedRoles(userDetails.map((detail: { customRoleId: string }) => detail.customRoleId));
      } else {
        // If user is not found, allow adding new user
        setUserId(value);
        setUserName(value);
        setDepartment('');
        setDepartmentName('');
        setBusinessUnitName('');
        setIsActive(true);
        setSelectedRoles([]);
      }
    } catch (error) {
      message.error('Failed to fetch user details');
    }
  };

  const handleSubmit = async () => {
    if (!userId || selectedRoles.length === 0) {
      message.error('Please fill in all required fields');
      return;
    }
  
    // Verify that the selected roles exist in the roles list
    const invalidRoles = selectedRoles.filter(roleId => !roles.some(role => role.customRoleId === roleId));
    if (invalidRoles.length > 0) {
      message.error('One or more selected roles do not exist');
      return;
    }
  
    try {
      await assignUserRole({ userId, customRoleId: selectedRoles, departmentId: department, departmentName, businessUnitName, isActive });
      message.success('User roles assigned successfully');
      setUserId('');
      setUserName('');
      setDepartment('');
      setDepartmentName('');
      setBusinessUnitName('');
      setIsActive(true);
      setSelectedRoles([]);
    } catch (error) {
      message.error('Failed to assign user roles');
    }
  };
  
  const handleRemoveAllRoles = async () => {
    if (!userId) {
      message.error('Please select a user');
      return;
    }

    try {
      await removeAllUserRoles({ userId });
      message.success('All roles removed successfully');
      setSelectedRoles([]);
    } catch (error) {
      message.error('Failed to remove roles');
    }
  };

  interface RemoveAllUserRolesParams {
    userId: string;
  }

  const removeAllUserRoles = async ({ userId }: RemoveAllUserRolesParams): Promise<void> => {
    try {
      const token = await fetchToken(); 
      await axios.delete(`${API_URL}/api/Roles/CustomUserRoles/${userId}`,{headers: {Authorization: `Bearer ${token}`}});
    } catch (error) {
      console.error("Error removing roles:", error);
    }
  };
  
  
  return (
    <div>
      <Form layout="vertical" onFinish={handleSubmit}>
        <Form.Item label="User Name" required>
          <Select
            showSearch
            placeholder="Search users"
            value={userName}
            onSearch={setSearchTerm}
            onChange={handleRecipientClick}
            filterOption={false}
            style={{ width: '100%' }}
          >
            {recipientSearchResults.map(user => (
              <Option key={user.id} value={user.id}>
                {user.displayName}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Select Role" required>
          <Select
            mode="multiple"
            value={selectedRoles}
            onChange={setSelectedRoles}
            placeholder="Select roles"
          >
            {roles.map(role => (
              <Option key={role.customRoleId} value={role.customRoleId}>{role.customRoleName}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Department">
          <Input value={department} onChange={(e) => setDepartment(e.target.value)} />
        </Form.Item>
        <Form.Item label="Department Name">
          <Input value={departmentName} onChange={(e) => setDepartmentName(e.target.value)} />
        </Form.Item>
        <Form.Item label="Business Unit Name">
          <Input value={businessUnitName} onChange={(e) => setBusinessUnitName(e.target.value)} />
        </Form.Item>
        <Form.Item label="Is Active">
          <Select value={isActive} onChange={(value) => setIsActive(value)} placeholder="Select status">
            <Option value={true}>Active</Option>
            <Option value={false}>Inactive</Option>
          </Select>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">Assign Roles</Button>
          <Button danger={true} onClick={handleRemoveAllRoles} style={{ marginLeft: '10px' }}>Remove All Roles</Button>
        </Form.Item>
        
      </Form>
    </div>
  );
};

export default UserRoleInput;